"use client";
import { FaqItemDto } from '@/projectRoot/api-client/interfaces/models/company/FaqGroup.dto';
import style from './faqItem.module.scss';
import Chevron from '../../../common/svg/Chevron';
import { useState } from 'react';

interface Props {
    item: FaqItemDto;
    opened?: string;
    classes?: string[];
}

const FaqItem = ({item, opened, classes = []}: Props) => {
    const [open, setOpen] = useState<boolean>(opened && opened == item.uid);
    const onClickOpenFaq = (open: boolean) => {
        setOpen(open);
    }

  return (
    <div className={`${style.faqItem} ${classes.join(' ')} ${open ? style.opened : ''}`}>
        <p className={style.question} onClick={() => onClickOpenFaq(!open)}>
            {item.question}
            <span className={style.chevron}>
                <Chevron width={14} height={14} />
            </span>
        </p>
        <div className={`${style.answer}`} dangerouslySetInnerHTML={{__html: item.answer}} />
    </div>
  )
};

export default FaqItem;
